import { createStandardAction, createAsyncAction } from 'typesafe-actions'
import { GetApiResponse, PaginationType } from '../../types/common'
import {
  ChecklistConfigTypeDetailReq,
  ChecklistSVCountTypeListResp,
  CommonResp,
  GetDataListResp,
  ChecklistSVCountTypeListReq,
} from './types'
import { History } from 'history'

export const reset = createStandardAction(
  'admin/checklistTypeConfig/RESET_ACTION'
)<void>()

export const sortingTask = createStandardAction(
  'admin/checklistTypeConfig/SORTING'
)<{
  name: string
  sort?: string
}>()

export const getDataListAction = createAsyncAction(
  'admin/checklistTypeConfig/GET_CONFIG_LIST_REQUEST',
  'admin/checklistTypeConfig/GET_CONFIG_LIST_SUCCESS',
  'admin/checklistTypeConfig/GET_CONFIG_LIST_FAILURE'
)<PaginationType, GetDataListResp, Error>()

export const getCountTypeListAction = createAsyncAction(
  'admin/checklistTypeConfig/GET_COUNT_TYPE_LIST_REQUEST',
  'admin/checklistTypeConfig/GET_COUNT_TYPE_LIST_SUCCESS',
  'admin/checklistTypeConfig/GET_COUNT_TYPE_LIST_FAILURE'
)<ChecklistSVCountTypeListReq, ChecklistSVCountTypeListResp, Error>()

export const createDataAction = createAsyncAction(
  'admin/checklistTypeConfig/CREATE_CONFIG_DETAIL_REQUEST',
  'admin/checklistTypeConfig/CREATE_CONFIG_DETAIL_SUCCESS',
  'admin/checklistTypeConfig/CREATE_CONFIG_DETAIL_FAILURE'
)<ChecklistConfigTypeDetailReq, CommonResp, any>()

export const updateDataAction = createAsyncAction(
  'admin/checklistTypeConfig/UPDATE_CONFIG_DETAIL_REQUEST',
  'admin/checklistTypeConfig/UPDATE_CONFIG_DETAIL_SUCCESS',
  'admin/checklistTypeConfig/UPDATE_CONFIG_DETAIL_FAILURE'
)<ChecklistConfigTypeDetailReq, CommonResp, any>()

export const resetEvent = createStandardAction(
  'admin/checklistTypeConfig/RESET_EVENT_ACTION'
)<void>()
